import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Faq } from '@/components';
import { useFaqs } from './useFaqs';
import styles from './index.module.less';
import { useLocales } from './useLocales';
export const Faqs = () => {
    const t = useLocales();
    const faqs = useFaqs();
    return (_jsxs("article", { className: styles.article, children: [_jsx("h1", { className: styles.title, children: t('FAQs') }), _jsx("div", { className: styles.faqList, children: faqs.map(({ title, answer }) => (_jsx(Faq, { title: title, children: answer }, title))) })] }));
};
